import { useMemo } from 'react';

import { ProductsType } from '../../pages/BatchTicket/components/DynamicAsset/constants';
import { FeatureToggle, useUnleashFlags } from '../../utils/useUnleashFlags';

export const useOrderOriginRequired = () => {
  const flags = useUnleashFlags(
    FeatureToggle.RequireOrderOriginForFixedIncomeBuy,
    FeatureToggle.RequireOrderOriginForFixedIncomeSell,
    FeatureToggle.RequireOrderOriginForDirectTreasuryBuy,
    FeatureToggle.RequireOrderOriginForDirectTreasurySell,
    FeatureToggle.RequireOrderOriginForFundsBuy,
    FeatureToggle.RequireOrderOriginForFundsSell,
    FeatureToggle.RequireOrderOriginForEquityBuy,
    FeatureToggle.RequireOrderOriginForEquitySell,
    FeatureToggle.RequireOrderOriginForStructuredOperationsBuy
  );

  const productsMapper = useMemo<{ [key in ProductsType]: boolean }>(
    () => ({
      fixedIncome: flags.b2bRequireOrderOriginForFixedIncomeBuy,
      fixedIncomeSell: flags.b2bRequireOrderOriginForFixedIncomeSell,
      directTreasury: flags.b2bRequireOrderOriginForDirectTreasuryBuy,
      directTreasurySell: flags.b2bRequireOrderOriginForDirectTreasurySell,
      funds: flags.b2bRequireOrderOriginForFundsBuy,
      fundsSell: flags.b2bRequireOrderOriginForFundsSell,
      equity: flags.b2bRequireOrderOriginForEquityBuy,
      equitySell: flags.b2bRequireOrderOriginForEquitySell,
      coes: flags.b2bRequireOrderOriginForStructuredOperationsBuy,
      clubs: false,
      publicOffers: false,
      privatePension: false,
    }),
    [flags]
  );

  const verifyProduct = (productId: ProductsType) => {
    return productsMapper[productId] ?? false;
  };

  return { verifyProduct };
};
